import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerModule } from "ngx-spinner";

import { MaterialModule } from "./material.module";
import { ProfileModule } from "./profile/profile.module";
import { OnlyNumberDirective } from "./directives/only-number.directive";
import { PrescriptionModule } from "./prescription/prescription.module";
import { MatPaginatorModule } from "@angular/material/paginator";
import { OnlyCharacterDirective } from "./directives/only-character.directive";
import { UTCtoLocalPipe } from "./utcto-local.pipe";

@NgModule({
  declarations: [
    OnlyNumberDirective,
    OnlyCharacterDirective,
    UTCtoLocalPipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    NgxSpinnerModule,
    ProfileModule,
    MaterialModule,
    PrescriptionModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    NgxSpinnerModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    ProfileModule,
    OnlyNumberDirective,
    PrescriptionModule,
    OnlyCharacterDirective,
    UTCtoLocalPipe,
  ],
})
export class SharedModule {}
